import { CardActionArea, Typography, useTheme } from '@mui/material'
import { FlexBox } from 'components/atoms'
import { useBetContext } from 'contexts/BetContext'

export const HorseButton = ({
    horseNumber,
    onClick
}: {
    horseNumber: string
    onClick: () => void
}) => {
    const theme = useTheme()
    const { mainColor } = useBetContext()

    return (
        <CardActionArea
            sx={{ width: 'fit-content' }}
            onClick={() => onClick && onClick()}
        >
            <FlexBox
                sx={{
                    height: 33,
                    width: 33,
                    backgroundColor: mainColor,
                    borderRadius: theme.spacing(0.5),
                    justifyContent: 'center'
                }}
            >
                <Typography
                    variant="title-16-bold"
                    sx={{ fontSize: 20, color: 'white' }}
                >
                    {horseNumber}
                </Typography>
            </FlexBox>
        </CardActionArea>
    )
}
